import { useEffect } from "react";

function Chatboatui() {


    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/df-messenger.js';
        script.async = true;
        document.body.appendChild(script);
    
        return () => {
          document.body.removeChild(script);
        };
      }, []);

    return ( <>
    <link rel="stylesheet" href="https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/themes/df-messenger-default.css"/>
<script src="https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/df-messenger.js"></script>

    {/* <link rel="stylesheet" href="https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/themes/df-messenger-default.css"/>
<script src="https://www.gstatic.com/dialogflow-console/fast/df-messenger/prod/v1/df-messenger.js"></script> */}
<df-messenger
  project-id="athenafintech-348308"
  agent-id="73c077e3-ef37-4959-ba32-7b25285aa7b0"
  language-code="en"
  max-query-length="-1">
  <df-messenger-chat-bubble
   chat-title="AskAthena">
  </df-messenger-chat-bubble>
</df-messenger>

{/* <df-messenger
  project-id="turing-seeker-412507"
  agent-id="56fc7b33-3c4d-4d9d-9eb7-8da92b5d16d5"
  language-code="en"
  max-query-length="-1">
  <df-messenger-chat-bubble
   chat-title="athena ask">
  </df-messenger-chat-bubble>
</df-messenger> */}
<style>
{`
          df-messenger {
            z-index: 999;
            position: fixed;
            bottom: 16px;
            right: 16px;
          }
        `}

</style></> );
}

export default Chatboatui;